import isEmpty from 'lodash/isEmpty';
import stringifyObject from 'stringify-object';
import beautify from 'js-beautify';

// constants
import { PAYWALL_V2_SCRIPT, PAYWALL_SCRIPT } from 'constants/index';

export const paywallHeadScriptV2 = `<script type="text/javascript" src="${PAYWALL_V2_SCRIPT}"></script>`;

export const paywallHeadScriptV3 = `<script type="text/javascript" src="${PAYWALL_SCRIPT}"></script>`;

const getBody = (assetId: number, jsCode: string) =>
  `<div id="inplayer-${assetId}" class="inplayer-paywall"></div>
<script>
    ${jsCode}
</script>`;

const getUnformattedJsCode = (merchantUuid: string, assetId: number, options: string, globalOptions: string) =>
  `var paywall = new InplayerPaywall('${merchantUuid}', [{ id: ${assetId} ${options} }] ${globalOptions});`;

export const getJsCode = (merchantUuid: string, assetId: number, options: any, globalOptions: any) => {
  const paywallOptionsString = `, options: ${stringifyObject(options)}`;
  const optionsString = isEmpty(options) ? '' : paywallOptionsString;
  const globalOptionsString = isEmpty(globalOptions) ? '' : `, ${stringifyObject(globalOptions)}`;

  const uglyJsCode = getUnformattedJsCode(merchantUuid, assetId, optionsString, globalOptionsString);
  const jsCode = beautify(uglyJsCode).replace(/\n/g, '\n    ');

  return jsCode;
};

export const getPaywallBodyScriptCode = (
  merchantUuid: string,
  assetId: number,
  options: object,
  globalOptions: object
) => {
  const jsCode = getJsCode(merchantUuid, assetId, options, globalOptions);

  return getBody(assetId, jsCode);
};
